import Backbone from 'backbone'

var Project = Backbone.Model.extend({
	section: 'projects',
	domainType: 'project',
	urlRoot: 'api/projects'
})

export default Project

Project.__filename__ = 'projects/project.js'
